import React from "react";
import { getWeekdayString } from "helpers/opening-hours-helper/opening-hours-helper";
import i18next from "i18next";
import { IOpeningHoursDisplayData, RelationalDay } from "types/openingHours";

export const OpeningHoursLabel = ({ openingStatus }: { openingStatus: IOpeningHoursDisplayData }) => {
	const { atRelation, at, weekday } = openingStatus;
	if (!at || at.length == 0) {
		return null;
	}

	if (atRelation == RelationalDay.Today) {
		return (
			<>
				{at.map((timeSlot, index) => (
					<React.Fragment key={index}>
						{`${timeSlot.opens} – ${timeSlot.closes}`}
						{index < at.length - 1 && <br />}
					</React.Fragment>
				))}
			</>
		);
	}

	if (atRelation == RelationalDay.Tomorrow) {
		return i18next.t("time_opens_tomorrow_at_x", { 0: at[0].opens });
	}

	if (atRelation == RelationalDay.OtherWeekday) {
		const translatedWeekday = getWeekdayString(weekday);
		return i18next.t("time_opens_at_x", {
			0: `${translatedWeekday} ${at[0].opens}`,
		});
	}

	return undefined;
};
